import { parseFrontmatter } from './parseFrontmatter';
import { resolveHelpArticleId } from './helpRegistry';

const articleModules = import.meta.glob('./articles/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

const articlesById = {};

Object.entries(articleModules).forEach(([path, raw]) => {
  const file = path.split('/').pop() || '';
  const id = file.replace(/\.md$/, '');
  if (!id) return;
  articlesById[id] = parseFrontmatter(raw);
});

export function getAvailableHelpArticleIds() {
  return Object.keys(articlesById).sort();
}

/**
 * Load a help article by id.
 * @param {string|null} articleId
 */
export function loadHelpArticleById(articleId) {
  if (!articleId) return null;
  return articlesById[articleId] || null;
}

/**
 * Load help for the current route pathname.
 */
export function loadHelpForPath(pathname) {
  const { articleId, pattern } = resolveHelpArticleId(pathname);
  const article = loadHelpArticleById(articleId);

  if (!article) {
    return {
      articleId,
      pattern,
      found: false,
      meta: {
        title: 'Help',
        summary: 'No help article is available for this page yet.',
      },
      body: [
        '## No help for this page yet',
        '',
        'Help content has not been written for this screen.',
        '',
        'Open **Support** in the sidebar to report a problem. Check a related page that has fuller documentation for how a feature works.',
      ].join('\n'),
    };
  }

  return {
    articleId,
    pattern,
    found: true,
    meta: article.meta,
    body: article.body,
  };
}
